import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { setStorageImplementation } from '@time-theft-analyzer/shared';
import { webStorage } from './services/webStorage';
import i18n from './i18n';

// Initialize platform-specific storage
setStorageImplementation(webStorage);

// Expose i18n instance for the shared AuthContext to drive language changes.
(window as any).__APP_I18N__ = i18n;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);